import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  BlogOutputModel,
  BlogStatus,
  FORM_MODE,
  RootState,
  TCb,
  UploadedImageModel,
  LanguageOutputModel,
  BlogCategoryApiOutputModel,
} from "../../../models";
import { BlogService, ImageService, FaqService } from "../../../services";
import { NotificationActions, AllLanguageListActions, AllLabelsActions } from "../../../store/actions";
import BlogFormPresenter from "./BlogForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./BlogForm.type";
import { v4 as uuidv4 } from "uuid";
import { ImageUtil, loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";
import { CATEGORY_TYPES } from "../../../constants";

class BlogFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,
      blogStatus: {
        status: false,
        timePublication: null,
      },
      newBlogContent: {},
      blogPictures: [],
      allLabels: this.props.all_labels.data,
      activeLang: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      languageOptions: this.props.all_language_list.data,
      categories: [],
      labels: [],
      faqs: [],
    };
  }

  onUploadAvatar = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    ImageService.uploadBlogImage(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            blogPictures: [
              {
                id: uuidv4(),
                src: ImageUtil.buildBlogImgSrc(res.data.data)!,
                alt: data.alt || "",
              },
            ],
          });
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Upload image failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Upload image failed",
        });
      });
  };

  onRemoveAvatar = (fileId: string) => {
    const avatars = this.state.blogPictures.filter((p) => p.id !== fileId);
    this.setState({
      blogPictures: avatars,
    });
  };

  onChangeBlogStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        blogStatus: {
          ...prevState.blogStatus,
          status,
        },
      };
    });
  };

  onChangeTimePublication = (date: string | null) => {
    this.setState((prevState) => {
      return {
        blogStatus: {
          ...prevState.blogStatus,
          timePublication: date,
        },
      };
    });
  };

  onUploadContentImgHandler() {
    const self = this as any;
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files![0];
      const formData = new FormData();

      formData.append("image", file);
      // Save current cursor state
      const range = self.quill.getSelection(true);
      // Insert temporary loading placeholder image
      // quill.insertEmbed(range.index, "image", `${window.location.origin}/images/loaders/placeholder.gif`);

      // Move cursor to right side of image (easier to continue typing)
      self.quill.setSelection(range.index + 1, 1);
      const res = await ImageService.uploadBlogImage(formData);

      // Remove placeholder image
      // quill.deleteText(range.index, 1);

      if (res && res.status === 201) {
        self.quill.insertEmbed(range.index, "image", ImageUtil.buildBlogImgSrc(res.data.data.picture));
      }
    };
  }

  onChangeBlogContent = (val: string, langId: string) => {
    this.setState((prevState) => ({
      newBlogContent: {
        ...prevState.newBlogContent,
        [langId]: val,
      },
    }));
  };

  onSubmit = (val: any) => {
    if (!this.state.blogPictures.length) {
      this.props.actions.enqueueSnackbar({
        type: AppNotifications.ERROR,
        message: "Please choose an image",
      });
      return;
    }

    if (!this.state.newBlogContent) {
      this.props.actions.enqueueSnackbar({
        type: AppNotifications.ERROR,
        message: "Please input blog content",
      });
      return;
    }

    const avatar = this.state.blogPictures[0];

    const imgSrc = ImageUtil.convertImgServerSrc(avatar.src, "blog");
    // const imgSrcs = [imgSrc];

    let newArr: any[] = [];
    this.state.languageOptions.forEach((e) => {
      const categoryId = val[`categoryBlogId${e.id}`];
      const cateIds = categoryId ? (Array.isArray(categoryId) ? categoryId : [categoryId]) : [];
      // const labelIds = val.labels.id ? [val.labels.id] : [];

      if (val[`title${e.id}`]) {
        let newObj = {
          languageId: e.id,
          title: val[`title${e.id}`] || null,
          status: this.state.blogStatus.status ? BlogStatus.PUBLISH : BlogStatus.UNPUBLISH,
          publishDate: this.state.blogStatus.timePublication,
          description: this.state.newBlogContent[e.id] || null,
          titleSEO: val[`titleSEO${e.id}`] || null,
          descriptionSEO: val[`descriptionSEO${e.id}`] || null,
          link: val[`link${e.id}`] || "",
          avatar: imgSrc,
          categoryIds: cateIds,
          author: val.author,
          labelIds: val.labels.map((e) => e.id) || [],
          shortDescription: val[`shortDescription${e.id}`] || null,
          qaIds: val.qaIds ? (Array.isArray(val.qaIds) ? val.qaIds : [val.qaIds]) : [],
        };

        const found = this.state.initData?.find((i) => i.languageId === e.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(newObj, {
            id: this.state.initData?.find((i) => i.languageId === e.id)?.id,
          });
        newArr.push(newObj);
      }
    });

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateBlog(newArr);
    } else {
      this.onUpdateBlog(newArr);
    }
  };

  onCreateBlog = (data) => {
    BlogService.createBlog(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create blog success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Create blog failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Create blog failed",
        });
      });
  };

  onUpdateBlog = (data) => {
    BlogService.updateBlog(this.props.blogCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Edit blog success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Edit blog failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Edit blog failed",
        });
      });
  };

  onDeleteBlog = () => {
    BlogService.deleteBlog(this.props.blogCode!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete blog success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete blog failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete blog failed",
        });
      });
  };

  onLoadBlogDetail = (blogCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      BlogService.getBlogById(blogCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: BlogOutputModel[] = res.data.data;
            const avatar = data[0].avatar
              ? {
                  id: data[0].id,
                  src: ImageUtil.buildBlogImgSrc(data[0].avatar)!,
                  alt: data[0].alt || "",
                }
              : undefined;
            data.forEach((e) => {
              this.setState((prevState) => ({
                newBlogContent: {
                  ...prevState.newBlogContent,
                  [e.languageId]: e.description || "",
                },
              }));
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                loading: false,
                initData: data,
                blogStatus: {
                  status: data[0].status === BlogStatus.PUBLISH,
                  timePublication: data[0].publishDate,
                },
                blogPictures: avatar ? [avatar] : [],
                labels: data[0].labels.map((e) => ({
                  id: e.labelId,
                  name: this.state.allLabels.find((i) => i.id === e.labelId)?.name || "",
                })),
              },
              () => {
                loadCallback(cb?.success);
              },
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  // onLoadLabels = async (cb? : TCb) => {
  //   this.setState({ allLabels: { data: [], loading: true },}, () => {
  //       BlogService.getAllLabels()
  //       .then((res) => {
  //         if (res && (res.status === 200 || res.status === 201)) {
  //           let labels: any[] = [...res.data.data];
  //           this.setState({
  //                 allLabels: {
  //                   ...res.data,
  //                   data: labels,
  //                   loading: false,
  //                 },
  //             },
  //             () => {
  //               loadCallback(cb?.success);
  //             }
  //           );
  //         }
  //       })
  //       .catch((err) => {});
  //     }
  //   );

  // };

  onChangeLanguage = (id: string) => {
    this.setState({ activeLang: id });
    this.onLoadBlogCategories(id);
  };

  onLoadBlogCategories = (languageId?: string) => {
    BlogService.filterCategories({
      limit: 150,
      type: CATEGORY_TYPES.POST,
      languageId: languageId,
    })
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          let cates: BlogCategoryApiOutputModel[] = res.data.data;
          this.setState({ categories: cates });
        }
      })
      .catch((err) => {
        this.setState({
          categories: [],
        });
      });
  };

  onCreateTag = (name: string, cb?: TCb) => {
    if (!name) {
      return;
    }

    BlogService.createLabel({ name: name })
      .then((res) => {
        if (res && (res.status === 201 || res.status === 200)) {
          this.props.actions.getAllLabels();
          loadCallback(cb?.success, { name, id: res.data.data.id });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create label failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create label failed" });
      });
  };

  render() {
    return (
      <BlogFormPresenter
        {...this.props}
        {...this.state}
        onUploadAvatar={this.onUploadAvatar}
        onRemoveAvatar={this.onRemoveAvatar}
        onChangeBlogStatus={this.onChangeBlogStatus}
        onChangeTimePublication={this.onChangeTimePublication}
        onUploadContentImgHandler={this.onUploadContentImgHandler}
        onChangeBlogContent={this.onChangeBlogContent}
        onSubmit={this.onSubmit}
        onDeleteBlog={this.onDeleteBlog}
        onChangeLanguage={this.onChangeLanguage}
        onCreateTag={this.onCreateTag}
      />
    );
  }

  componentDidMount() {
    if (this.props.blogCode) {
      this.onLoadBlogDetail(this.props.blogCode);
    }
    if (this.state.categories) {
      this.onLoadBlogCategories(this.state.activeLang);
    }
    FaqService.filterFaqs({ limit: 150 })
      .then((res) => {
        if (res && res.data) {
          let faqs: any[] = res.data;
          this.setState({ faqs: faqs });
        }
      })
      .catch(() => {});
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
      all_labels: state.all_labels,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(
        Object.assign(NotificationActions, AllLanguageListActions, AllLabelsActions),
        dispatch,
      ),
    }),
  )(BlogFormContainer),
);
